// extracted by mini-css-extract-plugin
export var copyright = "SubFooter-module--copyright--0610e";
export var logo = "SubFooter-module--logo--76e3d";
export var searchContainer = "SubFooter-module--search-container--39ec9";
export var subFooterContainer = "SubFooter-module--sub-footer-container--3a409";
export var subFooterNav = "SubFooter-module--sub-footer-nav--f4f15";